import type { QuoteDocument, OptionsDocument } from 'paintscout'
import type { QuoteItemSection } from '../..'
import getSubstrateAreas from '../../items/get-items/util/get-substrate-areas'

/**
 * Get area substrate keys for any grouped substrates
 */
export function getGroupSubstrateChildren({
  quote,
  options,
  section,
  keys,
  groupKey = ''
}: {
  quote: QuoteDocument
  options: OptionsDocument
  keys: string[]
  section: QuoteItemSection
  groupKey?: string
}): string[] {
  if (quote.version < 5) return []

  const substrateChildren = keys.reduce((substrates, key) => {
    const substrate = quote.substrates[key]
    if (substrate) {
      // If it is a substrate find what areaSubstrates are making it up in that section.
      const substrateAreas = getSubstrateAreas({
        quote,
        options: quote.options,
        clientOptions: options,
        substrateKey: key,
        consumer: 'customer',
        section,
        showValues: true,
        showGroup: groupKey.length > 0,
        groupKey
      })

      const areaSubstrateKeys = substrateAreas.map((areaSubstrate) => areaSubstrate.key)
      substrates = [...substrates, ...areaSubstrateKeys]
    }
    return substrates
  }, [])

  return substrateChildren
}
